import logo from "../media/logo-alt.png";
import xIcon from "../media/x.png";
import telegramIcon from "../media/telegram.png";

function Header() {
    return (
        <header className="header">

            <div className="container">

                <div className="row align-items-center">

                    {/* Logo */}

                    <div className="col-lg-3 col-4">

                        <a href="/" className="logo">

                            <img src={logo} alt="Tube" />

                        </a>

                    </div>

                    {/* Menu */}

                    <div className="col-lg-6 d-none d-lg-block">

                        <nav className="main-menu">

                            <a href="#about">ABOUT</a>

                            <a href="#memes">MEMES</a>

                            <a href="#token">TOKEN</a>

                            <a href="#community">COMMUNITY</a>

                        </nav>

                    </div>

                    {/* Right Side */}

                    <div className="col-lg-3 col-8">

                        <div className="header-right">

                            <a
                                href="https://x.com/Sirtube_sol"
                                target="_blank"
                                rel="noreferrer"
                                className="social-icon d-none d-lg-flex"
                            >
                                <img src={xIcon} alt="" />
                            </a>

                            <a
                                href="https://t.me/SIrTube"
                                target="_blank"
                                rel="noreferrer"
                                className="social-icon d-none d-lg-flex"
                            >
                                <img src={telegramIcon} alt="" />
                            </a>

                            <a
                                href="https://jup.ag/?sell=So11111111111111111111111111111111111111112&buy=GvgpSZJm2veVCLhWdwYVu3WSSVAXqyt6YcvWkyakpump"
                                target="_blank"
                                rel="noreferrer"
                                className="buy-btn"
                            >
                                BUY TUBE
                            </a>

                        </div>

                    </div>

                </div>

            </div>

        </header>
    );
}

export default Header;